export default __webpack_public_path__ + "static/media/wmap.67a55f9c.png";